<template>
  <div>
    <div @click="activateSelect=true;">
      <input
          class="selectBoxInputView"
          type="text"
          :value="selectValue"
          readonly
          v-show="false"
      />
      <div class="selectBoxInputView">
        {{ selectValue }}
      </div>
    </div>

    <popup v-if="activateSelect">
      <template #title>{{title}}</template>
      <template #content>
        <table class="tbl-form alignC pm-tbl-form" style="margin:0px;">
          <tbody class="pmTblFormTbody">
          <tr v-for="(item, key) in items" :key="key">
            <th>
              <input v-show="false"
                     type="radio"
                     :id="`${title}-${getSelectValue(item,key)}`"
                     :value="getSelectValue(item,key)"
                     v-model="select"
                     @change="$emit('update:val', select); activateSelect=false;"
                     readonly
              />
              <label style="padding-left: 10px;" :for="`${title}-${getSelectValue(item,key)}`"><span v-show="false"></span></label>
            </th>
            <td class="alignL" @click="$emit('update:val', getSelectValue(item,key)); activateSelect=false;">{{getSelectTitle(item)}}</td>
          </tr>
          </tbody>
        </table>
      </template>
    </popup>

  </div>

</template>

<script>
import Popup from '@/components/Popup/Popup.vue'

export default {
  name: "SelectRadioPopup",
  components: {Popup,},
  props: {
    optionValId:{
      type:Boolean,
      default:false,
    },
    title: String,
    disable: Boolean,
    selected: {
      type: [String, Number]
    },
    items: {
      type: [Array, Object]
    },
    val: null,
  },
  watch: {
    selected(val){
      this.select = val
    },
  },
  computed: {
    selectValue() {
      let value = this.title;
      let item = undefined;

      if(this.items){
        if(this.optionValId)
          item = this.items.find((i)=> i.id == this.select);
        else
          item = this.items[this.select];
      }

      if(item !== undefined)
        value = this.getSelectTitle(item);
      return value;
    }
  },

  data() {
    return {
      select: this.selected,
      activateSelect: false,
    };
  },

  methods: {
    getSelectValue(item, key) {return (this.optionValId) ? item.id: key},
    getSelectTitle(item) {
      // 차량 select 일경우 group_title 보여야한다
      return (typeof item.group != 'undefined' && typeof item.ids != 'undefined' && item.ids.length > 1)
          ? item.group
          : item.title
    }
  },
};
</script>

<style scoped>
</style>
